import type { ROLE } from '../common/role';
import { hasAnyPermission, hasPermission, useEffectiveRoles } from '../hooks/use-permission';

export type RestrictedProps = {
	/** Permission or array of permissions required to render the children. If "some" is true, user needs at least one of the permissions in "to" array, otherwise needs all permissions */
	to: ROLE | ROLE[];

	/** If true, user needs at least one of the permissions in "to" array, otherwise needs all permissions */
	some?: boolean;

	/** Content to render if user has required permissions */
	children: React.ReactNode;

	/** Content to render if user does not have required permissions */
	fallback?: React.ReactNode;
};

export function Restricted({ to = [], some = false, children, fallback = null }: RestrictedProps) {
	const roles = useEffectiveRoles();

	// If "some" is true, check if user has at least one of the permissions in "to" array, otherwise check if user has all permissions in "to" array.
	// Shared with usePermission so the two cannot drift; an empty `to` is denied either way.
	const allowed = some ? hasAnyPermission(roles, to) : hasPermission(roles, to);

	if (!allowed) {
		return fallback;
	}

	return <>{children}</>;
}
